module.exports = "https://static.wanderu.com/ui-react/_next/static/media/more.b7368e56.svg";